module.exports = __webpack_public_path__ + "img/login-true.ca3a4a53.gif";